// https://rawisglenn.medium.com/regex-crash-course-lookahead-and-password-validation-19fc2b2a299c
// .{6,}$                                          =>  >= 6 characters in length
// (?=.*[a-z])(?=.*[A-Z])                          =>  1 lower case alphabet + 1 upper case alphabet
// (?=.*\d)                                        =>  1 digit
// (?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹])   =>  1 special character
export const passwordRegex =
  /^(?=.*\d)(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_₹])(?=.*[a-z])(?=.*[A-Z]).{6,}$/; // eslint-disable-line no-useless-escape
